export default __webpack_public_path__ + "images/brasao.c0c13c802410bd9ce592e5a913cc0de7.png";